import React from 'react'
import CustomerFilter from './Filter/CustomerFilter'
import CustomerSearch from './Filter/CustomerSearch'

interface Props {
  stores: any,
  setCustomers: any,
  setCurrentStore: React.Dispatch<React.SetStateAction<{AnavezneKodu: string, AnavezneAdi: string}>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean | undefined>>
}

const FilterCustomers: React.FC<Props>  = ({stores, setCustomers, setCurrentStore, setIsLoading}) => {
  return (
    <div className='w-100'>
      <div className={`card card-xxl-stretch mb-5 mb-xl-4 w-100`}>
        
        <div className='row card-body pt-5 d-flex w-100 justify-content-start filter-area'>
          <div className='col-md-5'>
            <CustomerFilter stores={stores} setCustomers={setCustomers} setCurrentStore={setCurrentStore} setIsLoading={setIsLoading}/>
          </div>
          <div className="col-md-3">
            <CustomerSearch />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FilterCustomers
